/**
 * [ENGBEND-12942] Shapes for the data the dev mocks panel stands in for. They are deliberately
 * separate from `LDFlags`: these describe local test fixtures, not a LaunchDarkly rollout, and
 * nothing outside a developer's own browser should be able to set them.
 */

/**
 * Neuropsych episodes cannot be created yet (ENGBEND-12640), so these pin the entrypoint's inputs. Delete once real NP episodes exist.
 */
export interface NpTestPlanDevMocks {
  /** Treats the selected episode as neuropsych, whatever its program. */
  forceEpisode: boolean
  /** Treats the signed-in provider as a neuropsych tester. */
  forceRole: boolean
  /** Pins the intake-note gate open or shut. `undefined` reads the real notes. */
  intakeNoteCompleted?: boolean
}

export interface DevMocks {
  npTestPlan: NpTestPlanDevMocks
}

/** What every consumer sees in production, and before a developer has mocked anything. */
export const NO_DEV_MOCKS: DevMocks = {
  npTestPlan: {
    forceEpisode: false,
    forceRole: false,
    intakeNoteCompleted: undefined,
  },
}
